var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCourseELearning({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.721,
    height: 40.129,
    viewBox: "0 0 53.721 40.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(20.42 9.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5747",
    "data-name": "Path 5747",
    d: "M252.561,141.4l2.244.277a5.477,5.477,0,0,1-1.967,3.053,6.664,6.664,0,0,1-8.125-.646,6.765,6.765,0,0,1-1.647-4.856,7.078,7.078,0,0,1,1.664-5.018,5.635,5.635,0,0,1,4.319-1.787,5.48,5.48,0,0,1,4.2,1.75,6.948,6.948,0,0,1,1.628,4.922c0,.13,0,.322-.012.58H245.31a4.928,4.928,0,0,0,1.194,3.234,3.56,3.56,0,0,0,2.679,1.121,3.318,3.318,0,0,0,2.039-.628A4.161,4.161,0,0,0,252.561,141.4Zm-7.13-3.511h7.154a4.348,4.348,0,0,0-.82-2.426,3.33,3.33,0,0,0-2.691-1.254,3.448,3.448,0,0,0-2.515,1A3.964,3.964,0,0,0,245.431,137.889Z",
    transform: "translate(-243.066 -132.423)",
    fill: "#525252",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5748",
    "data-name": "Path 5748",
    d: "M280.163,126.085H230.642a1.6,1.6,0,0,0-1.6,1.6v30.267a1.6,1.6,0,0,0,1.6,1.6h20.417v3.776h-6.12v1.886h20.927v-1.886h-6.121v-3.776h20.418a1.6,1.6,0,0,0,1.6-1.6V127.685A1.6,1.6,0,0,0,280.163,126.085Zm-47.922,30.267V129.285h46.322v27.067Z",
    transform: "translate(-229.042 -126.085)",
    fill: "#525252",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourseELearning);
export default __webpack_public_path__ + "static/media/icon_course_eLearning.21957d6cc441bce32ff3d33c1ef7b6ed.svg";
export { ForwardRef as ReactComponent };